import type { UserRecord } from '@vlabs/api/artemy/model';

export const MIN_USER_SEARCH_LENGTH = 3;

export function mergeUsers(...userLists: (UserRecord[] | undefined)[]): UserRecord[] {
  const result: UserRecord[] = [];

  userLists.forEach((users) => {
    users?.forEach((user) => {
      if (!result.some(({ user_id: userId }) => userId === user.user_id)) {
        result.push(user);
      }
    });
  });

  return result;
}
